import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageTransition } from '../transitions/PageTransition';
import { useCursorContext } from '../../hooks/useCursorContext';

export function ImpressumPage() {
  const { setCursorState } = useCursorContext();

  return (
    <PageTransition>
      <div className="min-h-screen bg-[#0a0a0a] pt-32 pb-20">
        {/* Back Link */}
        <div className="fixed top-24 left-8 md:left-12 z-40">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/40 hover:text-emerald-500 transition-colors group"
            onMouseEnter={() => setCursorState('hovering')}
            onMouseLeave={() => setCursorState('default')}
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs tracking-wider uppercase">Zurück</span>
          </Link>
        </div>

        <div className="max-w-3xl mx-auto px-8 md:px-12">
          {/* Header */}
          <h1 className="text-4xl md:text-5xl font-light text-white mb-12">
            Impressum
          </h1>

          {/* Content */}
          <div className="space-y-10 text-white/70">
            {/* Angaben gemäß § 5 TMG */}
            <section>
              <h2 className="text-lg text-white mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="leading-relaxed">
                Niko Knez<br />
                Freelancer<br />
                Köln-Aachener-Straße 155<br />
                50127 Bergheim
              </p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-lg text-white mb-4">Kontakt</h2>
              <p className="leading-relaxed">
                Telefon: 01722965445<br />
                E-Mail:{' '}
                <a
                  href="mailto:info@design-nk.de"
                  className="text-emerald-500 hover:text-emerald-400 transition-colors"
                  onMouseEnter={() => setCursorState('hovering')}
                  onMouseLeave={() => setCursorState('default')}
                >
                  info@design-nk.de
                </a>
              </p>
            </section>

            {/* Umsatzsteuer-ID */}
            <section>
              <h2 className="text-lg text-white mb-4">Umsatzsteuer-ID</h2>
              <p className="leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE318700943
              </p>
            </section>

            {/* EU-Streitschlichtung */}
            <section>
              <h2 className="text-lg text-white mb-4">EU-Streitschlichtung</h2>
              <p className="leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-500 hover:text-emerald-400 transition-colors"
                  onMouseEnter={() => setCursorState('hovering')}
                  onMouseLeave={() => setCursorState('default')}
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            {/* Verbraucherstreitbeilegung */}
            <section>
              <h2 className="text-lg text-white mb-4">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-20 py-12 px-8 md:px-12 lg:px-24 border-t border-white/10">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="text-xs text-white/20">
              © {new Date().getFullYear()} NK Design
            </span>
            <span className="text-xs text-white/20">Köln, Deutschland</span>
          </div>
        </footer>
      </div>
    </PageTransition>
  );
}
